var map = {
	"./alert-icon.svg": "m73O",
	"./success-icon.svg": "ihRI",
	"./warning-icon.svg": "vhV1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/vel";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\-icon\.svg$
// module id = /vel
// module chunks = 6